import { makeStyles } from '@mui/styles'
const drawerWidth = 200

const useStyles = makeStyles((theme) => ({
    '@global': {
        html: {
            height: '100%',
        },
        body: {
            margin: '0 !important',
            height: '100%',
        },
    },
    root: {
        display: 'flex',
    },
    pageContent: {
        flexGrow: 1,
    },
    busyIndicator: {
        height: '1px',
    },
    paper: {
        padding: theme.spacing(16),
    },
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    navBarList: {
        paddingLeft: theme.spacing(2),
    },
    listSelected: {
        backgroundColor: '#7FA1C7',
    },
    title: {
        flexGrow: 1,
        textAlign: 'center',
    },
    toolbarButtons: {
        marginLeft: 'auto',
    },
    toolbar: {
        background: '#F6F7F9',
        minHeight: 63,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerContent: {
        background: '#153C65',
        height: '100%',
    },
    sidebarLogo: {
        background: '#0B2541',
        opacity: 1,
        color: '#FFFFFF',
        padding: theme.spacing(1),
    },
    sidebarList: {
        color: '#FFFFFF',
    },
    sidebarListM: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    AvatarSmall: {
        backgroundColor: '#57769A',
        cursor: 'pointer',
    },
    applogo: {
        opacity: 1,
        borderRadius: '112px',
        cursor: 'pointer',
    },
}))

export default useStyles
